import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';

type QrCheckinSheetProps = {
  isOpen: boolean;
  onClose: () => void;
  qrUrl?: string;
  experienceName: string;
  bookingDate: string;
};

export const QrCheckinSheet = ({ isOpen, onClose, qrUrl, experienceName, bookingDate }: QrCheckinSheetProps) => {
  const { t } = useTranslation();

  return (
    <Drawer
      anchor="bottom"
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          maxWidth: 540,
          mx: 'auto',
          pb: 'env(safe-area-inset-bottom)',
        },
      }}>
      <Grid container flexDirection="column" gap={2} sx={{ p: 3 }} alignItems="center">
        <Grid container justifyContent="center">
          <Grid
            item
            sx={{
              width: 40,
              height: 4,
              borderRadius: 2,
              backgroundColor: 'grey.300',
            }}
          />
        </Grid>

        <Typography variant="h6" fontWeight={700} align="center">
          {t('manage_passes.qrCheckin.title')}
        </Typography>
        <Typography variant="body2" color="text.secondary" align="center">
          {t('manage_passes.qrCheckin.subtitle', { experience: experienceName, date: bookingDate })}
        </Typography>

        {qrUrl ? (
          <Grid
            container
            justifyContent="center"
            sx={{
              backgroundColor: '#fff',
              borderRadius: 2,
              p: 2,
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            }}>
            <img
              src={qrUrl}
              alt={t('manage_passes.qrCheckin.imageAlt')}
              style={{ width: '100%', maxWidth: 260, height: 'auto', display: 'block' }}
            />
          </Grid>
        ) : (
          <Typography variant="body2" color="text.secondary" align="center">
            {t('manage_passes.qrCheckin.unavailable')}
          </Typography>
        )}

        <Button variant="contained" fullWidth size="large" onClick={onClose} sx={{ py: 1.5, fontWeight: 600 }}>
          {t('manage_passes.qrCheckin.close')}
        </Button>
      </Grid>
    </Drawer>
  );
};
